import React from "react";
import { Card, CardContent, Typography } from "@material-ui/core";

const CardFestiveDate = ({ date, name, color, brandColor }) => {
  return (
    <Card style={{
      border: 'solid 1px', borderColor: '#DFDFDF',
      borderRadius: '8px', boxShadow: "none"
    }}>
      <CardContent style={{
        display: 'flex', flexDirection: 'column', alignItems:
          'flex-start', justifyContent: 'center'
      }}>
        <div style={{
          backgroundColor: `${color}`, borderRadius: '100px', padding:
            '4px, 8px, 4px, 8px', height: '24px', marginBottom: '8px', display: 'flex',
          alignItems: 'center', justifyContent: 'center'
        }}>
          <Typography variant="h5" component="div" style={{
            fontFamily: 'Inter',
            fontWeight: '500', fontSize: '12px', lineHeight: '16px', color: `${brandColor}`,
            textAlign: 'center', padding: '4px, 8px, 4px, 8px'
          }}>
            <div style={{
              borderRadius: '100px',
              width: '200px',
              height: '24px',
              padding: '4px 8px',
            }}>
              <p>Datas comemorativas</p>
            </div>
          </Typography>
        </div>
        <Typography variant="subtitle1" color="textSecondary" style={{
          fontFamily:
            'Inter', fontWeight: '400', fontSize: '16px', lineHeight: '20px', color: '#2C2C2C'
        }}>
          <div style={{marginTop:"10px"}}>{date} | {name}</div>
        </Typography>
      </CardContent>
    </Card >
  );
};

export default CardFestiveDate;
